/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ExternalServiceConfig } from './ExternalServiceConfig.js';
import {
    ExternalServiceConfigFromJSON,
    ExternalServiceConfigFromJSONTyped,
    ExternalServiceConfigToJSON,
} from './ExternalServiceConfig.js';

/**
 * 
 * @export
 * @interface Hook
 */
export interface Hook {
    /**
     * 
     * @type {number}
     * @memberof Hook
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Hook
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Hook
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof Hook
     */
    events?: Array<string>;
    /**
     * 
     * @type {ExternalServiceConfig}
     * @memberof Hook
     */
    externalService?: ExternalServiceConfig;
}

/**
 * Check if a given object implements the Hook interface.
 */
export function instanceOfHook(value: object): boolean {
    return true;
}

export function HookFromJSON(json: any): Hook {
    return HookFromJSONTyped(json, false);
}

export function HookFromJSONTyped(json: any, ignoreDiscriminator: boolean): Hook {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'events': json['events'] == null ? undefined : json['events'],
        'externalService': json['externalService'] == null ? undefined : ExternalServiceConfigFromJSON(json['externalService']),
    };
}

export function HookToJSON(value?: Hook | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'isEnabled': value['isEnabled'],
        'events': value['events'],
        'externalService': ExternalServiceConfigToJSON(value['externalService']),
    };
}

